"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי?",
  answer: "אנו מתחייבים להגעת מטפל סיעודי ישראלי תוך עד 5 שעות בלבד מרגע הפנייה, בפריסה ארצית מלאה לבית המטופל או לבית החולים."
}, {
  question: "האם המטפלים שלכם הם ישראלים?",
  answer: "כן, ב-Siudy אנו מעסיקים מטפלים ומטפלות ישראלים בלבד. אנו מאמינים ששפה משותפת ורקע תרבותי דומה חיוניים להענקת טיפול איכותי, מכבד ומקצועי."
}, {
  question: "האם ניתן לקבל שירות השגחה בבית חולים?",
  answer: "בהחלט. השירות שלנו כולל ליווי והשגחה צמודה בבתי חולים בכל רחבי הארץ, כולל משמרות לילה וסופי שבוע, כדי להעניק למשפחה שקט נפשי מלא."
}, {
  question: "באילו אזורים בארץ אתם פועלים?",
  answer: "אנו מספקים שירותי סיעוד מיידיים בפריסה ארצית רחבה – מתל אביב והמרכז, דרך ירושלים וחיפה, ועד ליישובים מרוחקים יותר. המטפלים שלנו זמינים להגעה מהירה לכל נקודה."
}, {
  question: "מהם תנאי ההתקשרות והתשלום?",
  answer: "אצלנו אין צורך בחוזים ארוכי טווח או דמי הרשמה. השירות גמיש לחלוטין וניתן להזמנה לפי צורך – החל ממשמרות בודדות ועד ליווי רציף, בשיטת תשלום שקופה והוגנת."
}];
export default function Faq() {
  return <section data-section-id="180680" id="faq" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="bg-muted/30 backdrop-blur-sm rounded-[2rem] p-8 md:p-12 lg:p-16 shadow-sm border border-border/50">
          <div className="text-center mb-12">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight">
              שאלות נפוצות על שירותי סיעוד
            </h2>
            <p className="text-muted-foreground font-default text-lg max-w-2xl mx-auto leading-relaxed">
              כל מה שחשוב לדעת על שירותי הסיעוד המיידיים של Siudy – מטפלים ישראלים מקצועיים בזמינות של עד 5 שעות.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm data-[state=open]:shadow-md transition-all duration-200 last:border-b">
                  <AccordionTrigger className="px-6 py-5 hover:no-underline text-base md:text-lg font-default font-semibold text-primary [&>svg]:text-ring [&>svg]:size-6">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 pt-0 text-muted-foreground font-default text-base leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}